import React, { FC } from 'react';
import styled from 'styled-components';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { selectChatAlert, setChatAlert } from 'models/twilio';
import { useTranslation } from 'react-i18next';

const StyledSnackbar = styled(Snackbar)`
  &.MuiSnackbar-anchorOriginBottomLeft {
    position: absolute;
    bottom: 8px;
    left: 8px;
  }
`;

const ChatSnackbar: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const chatAlert = useSelector(selectChatAlert);

  const handleClose = (_event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') return;
    dispatch(setChatAlert(null));
  };

  if (!chatAlert) return null;
  return (
    <StyledSnackbar
      open={!!chatAlert}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <MuiAlert onClose={handleClose} severity={chatAlert.severity}>
        {chatAlert.translationKey ? t(chatAlert.translationKey, chatAlert.message as string) : chatAlert.message}
      </MuiAlert>
    </StyledSnackbar>
  );
};

export default ChatSnackbar;
